import DigitalAssetWithCountAndFileNameModel from '../../generated/types/model/resource/DigitalAssetWithCountAndFileNameModel';

export default class DigitalAssetWithCountAndFileNameViewModel extends DigitalAssetWithCountAndFileNameModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
